import { render, staticRenderFns } from "./GerenciamentoProdutos.vue?vue&type=template&id=00965416&scoped=true"
import script from "./GerenciamentoProdutos.vue?vue&type=script&lang=js"
export * from "./GerenciamentoProdutos.vue?vue&type=script&lang=js"
import style0 from "./GerenciamentoProdutos.vue?vue&type=style&index=0&id=00965416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00965416",
  null
  
)

export default component.exports